import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../app/store';
import { fetchCount } from '../api/counterAPI';
import { postRequest } from '../app/postRequest.service';
import { LoginRequest, LoginResponse } from '../interfaces/login';
import { loginApi } from '../api/loginAPI';
import { IEnrolmentReqPayload, MemberEnrolmentResponse } from '../interfaces/enrollment.interface';
import { enrolmentsApi } from '../api/enrollmentAPI';

export interface EnrollmentState {
  value: MemberEnrolmentResponse | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: EnrollmentState = {
  value: null,
  status: 'idle',
};

export const enrollmentAsync = createAsyncThunk(
  'enrollment/enrollmentAsync',
  async () => {
    const response = await enrolmentsApi()
    return response.data;
  }
);

export const enrollmentSlice = createSlice({
  name: 'enrollment',
  initialState,
  
  reducers: {
    // increment: (state) => { 
    //   state.value += 1;
    // },
    // decrement: (state) => {
    //   state.value -= 1;
    // },
    
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload;
    // },
  },
  
  
  extraReducers: (builder) => {
    builder
      .addCase(enrollmentAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(enrollmentAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value = action.payload;
      })
      .addCase(enrollmentAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { } = enrollmentSlice.actions;
export const getEnrollment = (state: RootState) => state.enrollment.value;
export const isEnrollmentLoading = (state: RootState) => state.enrollment.status === 'loading';

export default enrollmentSlice.reducer;
